import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
} from "react-native";
import { heightPercentageToDP as hp } from "../../Utils/responsive";

import "../../App.scss";

const IntroPage = (props) => {
  const [screenDimensions, setScreenDimensions] = useState(
    Dimensions.get("window")
  );

  // Handle dimension changes
  useEffect(() => {
    const onChange = ({ window }) => {
      setScreenDimensions(window);
    };

    Dimensions.addEventListener("change", onChange);

    return () => Dimensions.removeEventListener("change", onChange);
  }, []);

  return (
    <View style={styles.content}>
      <View style={styles.headingContainer}>
        <Text style={styles.header}>LET'S UNDERSTAND YOU...</Text>
      </View>
      <Text style={styles.customText}>
        How you feel about risk, your attitudes and your understanding.
        {"\n"}
        {"\n"}
        The next few screens take the form of interactive exercises.
        {"\n"}
        {"\n"}
        Please respond honestly without over thinking.
      </Text>
      <TouchableOpacity
        onPress={() => props.setShowIntroPage((prev) => !prev)}
        style={styles.button}
      >
        <Text style={styles.buttonText}>GET STARTED</Text>
      </TouchableOpacity>

      <div className="profiler-intro-bottom-image"></div>
    </View>
  );
};

export default IntroPage;
const styles = StyleSheet.create({
  content: {
    height: "100vh",
    width: "100vw",
    justifyContent: "center",
    alignItems: "center",
  },

  headingContainer: {
    width: "75%",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: hp("4%"),
  },
  header: {
    position: "relative",
    width: "100%",
    alignSelf: "center",
    fontWeight: "var(--font-weight-light)",
    fontSize: "var(--profiler-intro-header-font-size)",
    letterSpacing: "var(--profiler-intro-header-letter-spacing)",
    textAlignVertical: "center",
    textAlign: "center",
    color: "var(--text-color-default)",
    textTransform: "uppercase",
    paddingTop: "var(--profiler-intro-header-padding-top)",
    paddingBottom: 12,
    borderTopColor: "rgb(212, 212, 212)",
    borderBottomColor: "rgb(212, 212, 212)",
    borderBottomWidth: 1,
    borderTopWidth: 1,
  },
  customText: {
    position: "relative",
    width: "75%",
    fontFamily: "var(--font-family-default)",
    fontSize: "var(--profiler-intro-font-size)",
    fontStyle: "normal",
    textAlign: "center",
    color: "var(--profiler-intro-header-color)",
    marginBottom: hp("4%"),
    fontWeight: "var(--font-weight-light)",
    letterSpacing: "var(--profiler-intro-letter-spacing)",
  },
  button: {
    backgroundColor: "var(--module-color-atr)",
    minHeight: 48,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonText: {
    color: "#ffffff",
    fontWeight: "var(--font-weight-bold)",
    fontSize: "var(--button-font-size)",
    letterSpacing: "var(--button-letter-spacing)",
    padding: "10px",
  },
});
